import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Input } from 'src/registry/ui/Input';
import { cn } from 'src/utils/shadcn';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

function InputWithIcon({
    icon,
    className,
    wrapperProps,
    ...props
}: React.ComponentProps<typeof Input> & { wrapperProps?: React.ComponentProps<'div'>; icon: IconProp }) {
    const { className: wrapperClassName } = wrapperProps || {};

    return (
        <div className={cn('group relative', wrapperClassName)} {...wrapperProps}>
            <FontAwesomeIcon icon={icon} className="pointer-events-none absolute size-4 p-3 text-gray-500" />
            <Input className={cn('pl-10', className)} {...props} />
        </div>
    );
}

export { InputWithIcon };
